import { request } from 'graphql-request'
import useSWR from 'swr'
import { CONTENTFUL_API_URL } from './api'
import { IContentfulCategory } from './contentful.types'

const PREFIX = '@contentful/getArticleList'

async function categoryListFetcher(): Promise<IContentfulCategory[]> {
  const data = await request(
    CONTENTFUL_API_URL,
    `query {
      categoryCollection {
        items {
          name
          sys {
            id
          }
        }
      }
    }`
  )

  return data.categoryCollection.items
}

export const getCategoryList: () => Promise<IContentfulCategory[]> = categoryListFetcher

export function useCategoryList(fallbackData?: IContentfulCategory[]) {
  return useSWR<IContentfulCategory[]>(PREFIX, categoryListFetcher, {
    fallbackData,
  })
}
